<div class="preview-wrapper" [class.light-background]="isLightBackground">
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <button
    mat-icon-button
    class="download-btn-top"
    *ngIf="canDownload(files[currentCarouselIndex])"
    (click)="downloadFile(files[currentCarouselIndex])"
    title="Download"
  >
    <mat-icon>download</mat-icon>
  </button>

  <button
    mat-icon-button
    class="nav-btn prev"
    (click)="prevSlide()"
    [disabled]="currentCarouselIndex === 0"
    *ngIf="files.length > 1"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>

  <div class="content-container">
    <ng-container *ngIf="files.length > 0">
      <ng-container *ngIf="isImage(files[currentCarouselIndex])">
        <img
          [src]="getSafeUrl(files[currentCarouselIndex])"
          class="preview-media"
          alt="Preview"
        />
      </ng-container>

      <ng-container
        *ngIf="isVideo(files[currentCarouselIndex]) && currentSafeUrl"
      >
        <video #videoPlayer controls class="preview-media">
          <source
            [src]="currentSafeUrl"
            [type]="files[currentCarouselIndex].mimeType"
          />
        </video>
      </ng-container>

      <ng-container *ngIf="isDocument(files[currentCarouselIndex])">
        <iframe [src]="currentSafeUrl" class="preview-media doc-frame"></iframe>
      </ng-container>

      <ng-container *ngIf="isDownloadableFile(files[currentCarouselIndex])">
        <div class="file-preview-card">
          <mat-icon
            style="width: 60px; height: 60px"
            [svgIcon]="
              getFileIcon(getNormalizedFileType(files[currentCarouselIndex]))
            "
          ></mat-icon>
          <h3 class="file-name">{{ files[currentCarouselIndex].name }}</h3>
          <ng-container *ngIf="isCsv(files[currentCarouselIndex])">
            <p class="download-hint">Click to download the file</p>
            <button
              mat-raised-button
              color="primary"
              class="download-btn"
              (click)="downloadFile(files[currentCarouselIndex])"
            >
              <mat-icon>download</mat-icon>
              Download
            </button>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <button
    mat-icon-button
    class="nav-btn next"
    (click)="nextSlide()"
    [disabled]="currentCarouselIndex === files.length - 1"
    *ngIf="files.length > 1"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
